var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"service-container"},[_c('LevelInfo',{attrs:{"title":_vm.title}}),_c('ContentInfo',{attrs:{"content":_vm.content}}),_c('CostInfo',{attrs:{"list":_vm.list}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }